module.exports = "/images/vendor/jstree/dist/themes/default/32px.png?21bd42ab5782494e9227dd05c5b89c4d";